// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__4BG4a","description":"styles_description__vhosu","chip":"styles_chip__3F5Vr","skeleton-animation":"styles_skeleton-animation__bFhgx"};